import type { OfficialStatusLink as OfficialStatusLinkData } from "@/lib/conditions/ski/official-status-links";

/**
 * Outbound link to the operator's own lift and run status page (display only: PeakWave does
 * not ingest it). Opens in a new tab with rel="noopener noreferrer". The address list credit
 * lives in the page's data attribution block.
 */
export function OfficialStatusLink({ link, className = "" }: { link: OfficialStatusLinkData | null | undefined; className?: string }) {
  if (!link) return null;
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      data-official-status-link=""
      className={`inline-flex min-h-11 items-center gap-1.5 text-[12.5px] font-semibold text-teal-dark underline decoration-teal/40 underline-offset-2 hover:decoration-teal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 ${className}`}
    >
      Official lift and run status: {link.label}
      <span className="sr-only"> (opens in a new tab)</span>
      <span aria-hidden="true">↗</span>
    </a>
  );
}
